import { render, staticRenderFns } from "./zhuanti-lianghui.vue?vue&type=template&id=5c6df996&"
import script from "./zhuanti-lianghui.vue?vue&type=script&lang=js&"
export * from "./zhuanti-lianghui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports